import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Disclaimer() {
  return (
    <div >
      <Helmet>
        <title>Medical Disclaimer | BrightLife Physio Point</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
 <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                Medical Disclaimer
                </h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Medical Disclaimer</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div className="container my-5 legal-page">


<h3>General Information</h3>
        <p>
          The information provided on the BrightLife Physio Point website is
          intended for general informational and educational purposes only and
          should not be considered as medical advice, diagnosis, or treatment.
        </p>

        <p>
          All content on this website, including text, images, videos, graphics,
          and other material, is provided to help users understand physiotherapy,
          rehabilitation, wellness, and related services. This information does
          not replace professional medical consultation or diagnosis.
        </p>

        <h3>No Medical Advice</h3>
        <p>
          The content on this website is not intended to be a substitute for
          professional medical advice. Always seek the advice of a qualified
          physiotherapist, doctor, or healthcare provider regarding any medical
          condition or treatment.
        </p>

        <p>
          Do not delay or discontinue medical treatment based on information
          found on this website.
        </p>

        <h3>Individual Results May Vary</h3>
        <p>
          Results from physiotherapy and rehabilitation treatments vary from
          person to person depending on factors such as health condition,
          severity of injury, adherence to treatment plans, and lifestyle.
        </p>

        <p>
          BrightLife Physio Point does not guarantee specific outcomes from any
          treatment or service.
        </p>

        <h3>Exercise & Self-Care Disclaimer</h3>
        <p>
          Any exercises, stretches, or self-care techniques described on this
          website should be performed only after professional assessment and
          guidance. Attempting exercises without supervision may cause injury.
        </p>

        <h3>No Emergency Services</h3>
        <p>
          This website is not intended for emergency medical situations. If you
          experience severe pain, sudden injury, or a medical emergency, please
          seek immediate medical attention or contact emergency services.
        </p>

        <h3>External Links</h3>
        <p>
          This website may contain links to third-party websites or platforms
          such as YouTube or social media. BrightLife Physio Point does not
          control or endorse the content of these external sites.
        </p>

        <h3>Limitation of Liability</h3>
        <p>
          BrightLife Physio Point, its practitioners, and staff shall not be held
          liable for any injury, loss, or damage resulting from the use or misuse
          of information on this website.
        </p>

        <h3>Consent</h3>
        <p>
          By using this website, you acknowledge that you have read, understood,
          and agreed to this Medical Disclaimer.
        </p>
    </div>
    </div>
  );
}
